import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, PrinterIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const miniBadges = [{
  emoji: '📗',
  label: '6 Volumes + Run of Show'
}, {
  emoji: '💬',
  label: '348 Word-for-Word Direction Lines'
}, {
  emoji: '🎨',
  label: '200+ Illustrated Poses'
}, {
  emoji: '⏱',
  label: 'Family Formals in 12 Minutes'
}, {
  emoji: '🎁',
  label: '5 Field Bonuses'
}, {
  emoji: '🌍',
  label: 'Works in Any Country'
}];
const trustItems = [{
  Icon: LockIcon,
  label: 'Secure checkout'
}, {
  Icon: ZapIcon,
  label: 'Instant download'
}, {
  Icon: ShieldCheckIcon,
  label: '30-day guarantee'
}, {
  Icon: PrinterIcon,
  label: 'Digital (PDF) — print what you need'
}];
export function Hero() {
  return <section className="relative w-full bg-ivory overflow-hidden" data-id="element-169" data-mp="nbyir4alzley">
      <div className="mx-auto max-w-6xl px-5 pt-10 pb-16 sm:pt-16 sm:pb-24" data-id="element-170" data-mp="3d2l8r9xwn0zn">
        <div className="flex justify-center" data-id="element-171" data-mp="381xkux4z309n">
          <span className="inline-flex max-w-2xl items-center gap-2.5 border border-gold-soft bg-gold-tint px-4 py-2.5 text-center text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-ink-soft" data-id="element-172" data-mp="3814a7l2w7qm8">
            <span aria-hidden="true" className="text-gold-dark" data-id="element-173" data-mp="3o6u697yqynbv">
              ◆
            </span>
            Direct the Day™ — Not a posing guide. The word-for-word direction system for
            the entire wedding day.
          </span>
        </div>

        <h1 className="mt-8 text-center font-serif text-[2.1rem] leading-[1.12] sm:text-6xl sm:leading-[1.08] text-ink" data-id="element-174" data-mp="30hrfnam4xk58">
          Direct every wedding day like a{' '}
          <span className="italic text-gold-dark" data-id="element-175" data-mp="2qjv8sv08dbcx">$10,000 photographer.</span>
          <br className="hidden sm:block" data-id="element-176" data-mp="2qhqudj4pgtye" /> Even if your mind goes blank after five poses.
        </h1>

        <div className="rule-gold mx-auto mt-8 w-40" aria-hidden="true" data-id="element-177" data-mp="2vgu25bc2lea2" />

        <p className="mx-auto mt-8 max-w-3xl text-center text-base sm:text-lg leading-relaxed text-ink-soft" data-id="element-178" data-mp="2hjoz7k7nkvj1">
          The complete 6-volume direction system for wedding photographers — 300+ pages of
          word-for-word direction lines, illustrated poses, printable shot lists and
          break-point timelines. From getting ready to the send-off, in the order it
          actually happens on a Saturday.
        </p>

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-179" data-mp="i9vr34bbm0lu">
          {miniBadges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 rounded-full border border-ink/10 bg-white px-3.5 py-1.5 text-xs text-ink-soft" data-id="element-180" data-mp="1azul7e4dgnxd">
              <span aria-hidden="true" data-id="element-181" data-mp="111okgzuaxnu3">{badge.emoji}</span>
              {badge.label}
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-182" data-mp="x0l8iofdkby5">
          <CtaButton data-id="element-183" data-mp="3ltgm7o0v2mna">Get Direct the Day — Instant Access</CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-184" data-mp="3hrd96uyjn9zw">
          {trustItems.map(({
          Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-2" data-id="element-185" data-mp="21awca5mhyleu">
              <Icon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-186" data-mp="21b631vfd8wll" />
              {label}
            </li>)}
        </ul>

        <figure className="mt-14 sm:mt-16" data-id="element-187" data-mp="2b195sncahox4">
          <div className="mx-auto max-w-4xl border border-gold-soft bg-white p-3 shadow-card" data-id="element-188" data-mp="2b2agurtb2beu">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/51beaf67-8396-47c5-8664-6d7a5d4aa067.jpg" alt="The printed volumes of Direct the Day fanned out beside a camera, with the one-page Family Formals run sheet clipped to the camera bag" className="w-full object-cover" loading="eager" data-id="element-189" data-mp="2fzamx2q5ne5y" />
          </div>
        </figure>
      </div>
    </section>;
}